import React, { useContext, useEffect, useRef, useState } from "react"

import { useSnackbar } from "../../../../utils/notificacoes"
import RegistradorContext from "../../../../contexts/registradorContext"

import AppBar from "@material-ui/core/AppBar"
import Avatar from "@material-ui/core/Avatar"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import ButtonGroup from "@material-ui/core/ButtonGroup"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import Divider from "@material-ui/core/Divider"
import Drawer from "@material-ui/core/Drawer"
import FormControl from "@material-ui/core/FormControl"
import IconButton from "@material-ui/core/IconButton"
import InputLabel from "@material-ui/core/InputLabel"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import ListItemText from "@material-ui/core/ListItemText"
import ListSubheader from "@material-ui/core/ListSubheader"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import Slide from "@material-ui/core/Slide"
import { makeStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import AddIcon from "@material-ui/icons/Add"
import RemoveIcon from "@material-ui/icons/Remove"
import ArrowBackIcon from "@material-ui/icons/ArrowBack"
import CloseIcon from "@material-ui/icons/Close"
import Fab from "@material-ui/core/Fab"
import Skeleton from "@material-ui/lab/Skeleton"
import Product from "./components/Produto"
// TODO: Remover clsx
import clsx from "clsx"
import PropTypes from "prop-types"
import { Card, Col, Row } from "react-bootstrap"

import Comida from "../../../../assets/comida.svg"
import Megafone from "../../../../assets/megafone.svg"

import { RegistrarLogErro } from "../../../../services/clientefiel"

import {
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    Grid,
    Popover,
    Switch,
} from "@material-ui/core"
import {
    AddShoppingCart,
    AirlineSeatReclineNormal,
    ConfirmationNumber,
    Motorcycle,
    Person,
    Settings,
    TransferWithinAStation,
} from "@material-ui/icons"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import useParametros from "../../../../contexts/ParametrosContext"
import {
    calcularValorTotal,
    CONFIG_TELA_KEY,
    lerConfigTela,
    procurarCategoria,
    procurarProduto,
    produtoProntoParaCarrinho,
} from "../../../../pages/RegistradorDePedidos/functions"
import useAppStore from "../../../../stores/AppStore"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

// Largura do carrinho fixo à direita (desktop). É o PADRÃO — o operador pode
// arrastar a borda esquerda do painel para redimensionar, e a largura escolhida
// fica salva por estação (localStorage). Também reserva o espaço do conteúdo para
// o carrinho não cobrir os produtos. Os limites evitam um painel fino demais
// (inútil) ou largo demais (engolindo o cardápio).
const CART_WIDTH_PADRAO = 340
const CART_WIDTH_MIN = 280
const CART_WIDTH_MAX = 640
const CART_WIDTH_KEY = "registradorLarguraCarrinho"

const lerLarguraCarrinho = () => {
    try {
        const salvo = Number(localStorage.getItem(CART_WIDTH_KEY))
        if (!salvo) return CART_WIDTH_PADRAO
        return Math.min(CART_WIDTH_MAX, Math.max(CART_WIDTH_MIN, salvo))
    } catch {
        return CART_WIDTH_PADRAO
    }
}

function TabPanel(props) {
    const { children, ...other } = props

    return (
        <div role="tabpanel" {...other}>
            <Box p={3}>
                <div>{children}</div>
            </Box>
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
}

const useStyles = makeStyles(theme => ({
    fixed: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedMesa: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 2000,
    },
    fixedMesaFechar: {
        position: "fixed",
        right: "2em",
        bottom: "7em",
        zIndex: 2000,
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        // zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    heading: {
        width: "100%",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    appBar: {
        position: "fixed",
    },
    // Carrinho e "Voltar" saíram da antiga barra de topo (agora ocupada pelo Cabeçalho
    // padrão) e viraram botões flutuantes, sempre na ÁREA VISÍVEL da tela.
    fixedCarrinho: {
        position: "fixed",
        right: "1.5em",
        bottom: "1.5em",
        zIndex: 1200,
    },
    // Carrinho SEMPRE visível à direita (desktop), no lugar do Drawer que abria/fechava.
    cartPanel: {
        position: "fixed",
        top: "calc(64px + var(--banner-height, 0px))",
        right: 0,
        bottom: 0,
        // A largura é dinâmica (redimensionável) e vem inline no <aside>; o padrão é
        // CART_WIDTH_PADRAO. `position: fixed` também serve de âncora para a alça abaixo.
        backgroundColor: "#fff",
        boxShadow: "-2px 0 8px rgba(0,0,0,0.08)",
        zIndex: 1200,
        // O painel não rola inteiro: vira um flex column onde só a lista de itens
        // rola e o botão "Finalizar" fica fixo no rodapé.
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    // Alça de redimensionamento na borda ESQUERDA do carrinho (desktop). Fica por
    // cima do conteúdo (absolute) e captura o arraste (mouse ou toque). O tracinho
    // central e o realce no hover indicam que dá pra arrastar.
    cartResizeHandle: {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        width: 10,
        cursor: "col-resize",
        zIndex: 2,
        touchAction: "none",
        "&:hover": {
            backgroundColor: "rgba(40,167,69,0.12)",
        },
        "&::after": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 4,
            height: 40,
            borderRadius: 4,
            backgroundColor: "rgba(0,0,0,0.18)",
        },
    },
    appContainer: {
        // Empurra o conteúdo abaixo do Cabeçalho fixo. Dentro de um Dialog fullScreen o
        // padding-top que o Cabeçalho aplica no <body> não vale, então clareamos aqui;
        // --banner-height (setado pelo Cabeçalho) cobre as faixas quando aparecem.
        paddingTop: "calc(64px + var(--banner-height, 0px) + 1em)",
        backgroundColor: "#f4f4f4",
        // height: "100%",
        // minHeight: "-webkit-fill-available",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
}))

const TaxaAdicional = () => {
    const parametros = useParametros()
    const idPedidoURL = new URLSearchParams(window.location.search).get("idPedido")
    const [idPedido] = useState(idPedidoURL ? Number(idPedidoURL) : null)
    if (!parametros.PUBLIC_TAXA_ADICIONAL || idPedido) return null

    return (
        <ListItem button divider>
            <ListItemAvatar>
                <Avatar>
                    <AddIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={
                    "Taxa adicional: " +
                    Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }).format(parametros.PUBLIC_TAXA_ADICIONAL)
                }
            />
        </ListItem>
    )
}

export default function Index({ iframe }) {
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )

    const {
        cliente,
        setCliente,
        listaRepeticao,
        setProdutoSelecionado,
        loadingCardapio,
        setLoadingCardapio,
        setOpenFinalizacaoPedido,
        isRetiradaNoLocal,
        isDelivery,
        setCarrinho,
        cardapio,
        openCardapio,
        produtoSelecionado,
        carrinho,
        valorDescontoManual,
        setValorDescontoManual,
        ativarDesativarDesconto,
        ativoMinimoEntregaGratis,
        descontoAtivo,
        setOpenCardapio,
        isFreteGratisDesconto,
        isFreteGratisMinimoEntrega,
        descontoAtivoPagamento,
        handleToggleParteInicial,
        idPedido,
        pedidoEditar,
        estabelecimentosDisponiveis,
        openParteInicial,
        descontoCliente,
        mesa,
        pedidosDaMesa,
    } = useContext(RegistradorContext)

    const classes = useStyles()
    const history = useHistory()
    const { enqueueSnackbar } = useSnackbar()
    const configuracoes = useAppStore(s => s.configuracoes)
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    // Largura do carrinho lateral (desktop), redimensionável arrastando a borda
    // esquerda do painel. `larguraCarrinho` dispara o re-render; a ref acompanha o
    // valor ao vivo durante o arraste, para salvar no localStorage só ao soltar
    // (não a cada pixel).
    const [larguraCarrinho, setLarguraCarrinho] = useState(lerLarguraCarrinho)
    const larguraCarrinhoRef = useRef(larguraCarrinho)

    // Redimensiona o carrinho: a nova largura é a distância da borda direita da
    // janela até o ponteiro, limitada entre MIN e MAX. Usa Pointer Events, então
    // funciona igual com mouse e com toque (POS touchscreen).
    const iniciarRedimensionarCarrinho = eventoInicial => {
        eventoInicial.preventDefault()
        document.body.style.userSelect = "none"
        document.body.style.cursor = "col-resize"

        const aoMover = evento => {
            const nova = window.innerWidth - evento.clientX
            const limitada = Math.min(CART_WIDTH_MAX, Math.max(CART_WIDTH_MIN, nova))
            larguraCarrinhoRef.current = limitada
            setLarguraCarrinho(limitada)
        }

        const aoSoltar = () => {
            document.body.style.userSelect = ""
            document.body.style.cursor = ""
            window.removeEventListener("pointermove", aoMover)
            window.removeEventListener("pointerup", aoSoltar)
            try {
                localStorage.setItem(CART_WIDTH_KEY, String(larguraCarrinhoRef.current))
            } catch {
                // localStorage indisponível: mantém a largura só em memória.
            }
        }

        window.addEventListener("pointermove", aoMover)
        window.addEventListener("pointerup", aoSoltar)
    }

    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set())
    const [modoEdicao, setModoEdicao] = React.useState(false)
    const [indiceItemEmEdicao, setIndiceItemEmEdicao] = React.useState(null)
    const [idCategoriaSelecionada, setIdCategoriaSelecionada] = React.useState()
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    })
    const deepClone = obj => JSON.parse(JSON.stringify(obj))

    const handleCloseCardapio = () => {
        history.push("/servicos")
    }

    const toggleDrawer = (anchor, open) => event => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return
        }
        setState({ ...state, [anchor]: open })
    }

    const tipoLocal = localStorage.getItem("tipoPedido")
    const [tipo, setTipo] = useState(tipoLocal ?? "")
    const tipoEntregas = ["DELIVERY", "PEDIDO_MESA", "REGISTRADOR"]
    const textoTipoEntregas = {
        DELIVERY: "Delivery",
        PEDIDO_MESA: "Pedido de mesa",
        REGISTRADOR: "Registrador",
    }

    const encontrarIdCategoriaDoProduto = produtoId => {
        for (const cat of cardapio?.categorias || []) {
            if ((cat.produtos || []).some(p => p.id === produtoId)) return cat.id
        }
        return undefined
    }

    const atualizarProdutoParaEdicao = itemCarrinho => {
        const catId = encontrarIdCategoriaDoProduto(itemCarrinho.produto.id)

        const produtoCompleto =
            deepClone(
                (cardapio?.categorias?.find(c => c.id === catId)?.produtos || []).find(
                    p => p.id === itemCarrinho.produto.id
                )
            ) || deepClone(itemCarrinho.produto)

        produtoCompleto.quantidade = itemCarrinho.quantidade || 1
        ;(produtoCompleto.opcoes || []).forEach(gr => {
            gr.quantidade = 0
            ;(gr.opcoes || []).forEach(op => (op.quantidade = 0))
        })
        ;(itemCarrinho.itensOpcaoProduto || []).forEach(ad => {
            const optId = ad.opcaoProduto?.id
            const qtd = ad.quantidade || 0
            if (!optId || !qtd) return
            for (const grupo of produtoCompleto.opcoes || []) {
                const op = (grupo.opcoes || []).find(o => o.id === optId)
                if (op) {
                    op.quantidade += qtd
                    grupo.quantidade = (grupo.quantidade || 0) + qtd
                    break
                }
            }
        })

        return { produto: produtoCompleto, catId }
    }

    const abrirEdicaoItem = (item, index) => e => {
        if (e?.type === "keydown" && (e.key === "Tab" || e.key === "Shift")) return
        const { produto, catId } = atualizarProdutoParaEdicao(item)

        setModoEdicao(true)
        setIndiceItemEmEdicao(index)
        setProdutoSelecionado(produto)
        setIdCategoriaSelecionada(catId)
        setActiveStep(0)
        setState(prev => ({ ...prev, right: false, bottom: true }))
    }

    const salvarEdicaoProduto = (anchor, open) => e => {
        try {
            setOpenFinalizacaoPedido(false)
            if (e?.type === "keydown" && (e.key === "Tab" || e.key === "Shift")) return

            const produtoEdicao = deepClone(produtoSelecionado)

            const grupoExtraIndexes = (produtoEdicao.opcoes || []).reduce((acc, op, idx) => {
                if (op.grupoExtra) acc.push(idx)
                return acc
            }, [])

            const produtoSuccess = produtoProntoParaCarrinho(produtoEdicao)

            for (let i = grupoExtraIndexes.length - 1; i >= 0; i--) {
                produtoEdicao.opcoes.splice(grupoExtraIndexes[i], 1)
            }

            let cart = Object.assign({}, carrinho)
            cart.itens.splice(indiceItemEmEdicao, 1, produtoSuccess)

            cart = calcularValorTotal({
                descontoAtivoPagamento,
                carrinho: cart,
                cardapio,
                descontoAtivo,
                isDelivery,
                ativoMinimoEntregaGratis,
                valorDescontoManual,
                taxaServico: carrinho.taxaServico,
                descontoCliente,
            })

            setCarrinho(cart)

            setModoEdicao(false)
            setIndiceItemEmEdicao(null)
            setActiveStep(0)
            setState(prev => ({ ...prev, [anchor]: open }))
        } catch (error) {
            RegistrarLogErro(error, "salvarEdicaoProduto", {
                indiceItemEmEdicao,
                produtoSelecionado,
            })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    // Ajusta a quantidade de UM item do carrinho (pelo índice), +1 ou -1 respeitando
    // qntMultiplicativa/qntMinima. Se cair abaixo do mínimo (ou zero), remove o item.
    const alterarQuantidadeItem = (index, delta) => {
        try {
            let cart = Object.assign({}, carrinho)
            const item = cart.itens[index]
            if (!item) return

            const valorUnitario = item.valorProdutoHistorico / item.quantidade
            const passo = item.produto.qntMultiplicativaProdutos
                ? item.produto.qntMultiplicativaProdutos
                : 1
            const qntMinima = item.produto.qntMinimaProdutos || 0
            const novaQtd = item.quantidade + delta * passo

            if (novaQtd <= 0 || novaQtd < qntMinima) {
                cart.itens.splice(index, 1)
            } else {
                item.quantidade = novaQtd
                item.valorProdutoHistorico = valorUnitario * novaQtd
            }

            cart = calcularValorTotal({
                descontoAtivoPagamento,
                carrinho: cart,
                cardapio,
                descontoAtivo,
                isDelivery,
                ativoMinimoEntregaGratis,
                valorDescontoManual,
                taxaServico: carrinho.taxaServico,
                descontoCliente,
            })
            setCarrinho(cart)
        } catch (error) {
            RegistrarLogErro(error, "alterarQuantidadeItem", { index, delta })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    // Esvazia o carrinho atual (itens + desconto manual), mantendo cliente/endereço/mesa
    // já selecionados — é um "recomeçar o pedido", não um sair da tela. A confirmação vem
    // de um Dialog próprio (openConfirmarLimparPedido), não de window.confirm.
    const [openConfirmarLimparPedido, setOpenConfirmarLimparPedido] = useState(false)

    const pedirConfirmacaoLimparPedido = () => {
        if (!carrinho?.itens?.length) return
        setOpenConfirmarLimparPedido(true)
    }

    const confirmarLimparPedido = () => {
        try {
            setOpenConfirmarLimparPedido(false)

            setValorDescontoManual(0.0)
            const cart = Object.assign({}, carrinho, { itens: [] })
            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: cart,
                    cardapio,
                    descontoAtivo,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual: 0.0,
                    taxaServico: carrinho.taxaServico,
                    descontoCliente,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "limparPedido")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const customParams = JSON.parse(localStorage.getItem("custom-params") ?? "{}")
    const taxaAdicional = customParams.PUBLIC_TAXA_ADICIONAL

    const valorTotalExibicao = idPedido
        ? (Number(pedidoEditar?.valorTotal) || 0) + (Number(carrinho.valorTotal) || 0)
        : carrinho.valorTotal

    // Quantidade total de itens no carrinho (soma das quantidades). Usada no botão
    // "Finalizar" do rodapé mobile — o valor só aparece na tela de fechamento.
    const quantidadeItensCarrinho = (carrinho?.itens || []).reduce(
        (total, item) => total + (Number(item.quantidade) || 0),
        0
    )

    // Só faz sentido trocar o cliente num pedido novo de 1 estabelecimento (não em
    // edição de pedido nem em pedido de mesa).
    const podeTrocarCliente =
        estabelecimentosDisponiveis?.length === 1 && !idPedido && carrinho?.tipoPedido !== 2

    // Número da mesa (pedido de mesa): pode vir do estado `mesa` (URL/edição), do
    // pedidosDaMesa (fluxo Mesas Abertas) ou do próprio carrinho.
    const numeroMesaExibicao =
        mesa ||
        pedidosDaMesa?.numeroMesa ||
        (carrinho?.mesa && typeof carrinho.mesa === "object"
            ? carrinho.mesa.numeroMesa
            : carrinho?.mesa)

    // Reabre a tela de seleção de cliente (mesma do início). Espelha o botão "trocar
    // cliente" (ícone Person) da Finalização: zera cliente/endereço e reabre a ParteInicial.
    const abrirSelecaoCliente = () => {
        try {
            setCliente(false)
            carrinho.cliente = {}
            carrinho.end = {}
            setOpenFinalizacaoPedido(false)
            setCarrinho(calcularValorTotal({ carrinho }))
            handleToggleParteInicial()
        } catch (error) {
            RegistrarLogErro(error, "abrirSelecaoCliente")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const list = anchor => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === "top" || anchor === "bottom",
            })}
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
            role="presentation"
        >
            {
                <List
                    component="div"
                    aria-labelledby="nested-list-subheader"
                    className={classes.rootCarrinho}
                    style={{
                        flex: 1,
                        minHeight: 0,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            minHeight: 0,
                            overflowY: "auto",
                        }}
                    >
                        {/* No mobile o carrinho ocupa a tela toda (é um Drawer), então
                            precisa de um atalho para voltar ao cardápio e adicionar mais
                            itens. No desktop o cardápio fica sempre visível ao lado. */}
                        {mobile && anchor === "right" && (
                            <>
                                <ListItem style={{ paddingTop: 12, paddingBottom: 12 }}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        startIcon={<ArrowBackIcon />}
                                        onClick={toggleDrawer("right", false)}
                                        style={{
                                            color: "#28a745",
                                            borderColor: "#28a745",
                                        }}
                                    >
                                        Adicionar produtos
                                    </Button>
                                </ListItem>
                                <Divider />
                            </>
                        )}
                        {/* Pedido de mesa: mostra o número da mesa no topo do carrinho. */}
                        {carrinho?.tipoPedido === 2 && numeroMesaExibicao != null && (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: "#007bff" }}>
                                            <AirlineSeatReclineNormal />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`Mesa ${numeroMesaExibicao}`}
                                        secondary="Pedido de mesa"
                                    />
                                </ListItem>
                                <Divider />
                            </>
                        )}
                        {/* Opção SEMPRE visível no topo do carrinho para selecionar/trocar
                            o cliente (mesma tela do início). Só não aparece em edição de
                            pedido, pedido de mesa ou multi-estabelecimento. */}
                        {podeTrocarCliente && (
                            <>
                                <ListItem button onClick={abrirSelecaoCliente}>
                                    <ListItemAvatar>
                                        <Avatar
                                            style={{
                                                backgroundColor: carrinho?.cliente?.nome
                                                    ? "#28a745"
                                                    : undefined,
                                            }}
                                        >
                                            <Person />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            carrinho?.cliente?.nome
                                                ? carrinho.cliente.nome
                                                : "Selecionar cliente"
                                        }
                                        secondary={
                                            carrinho?.cliente?.nome
                                                ? "Trocar cliente"
                                                : "Toque para selecionar o cliente"
                                        }
                                    />
                                </ListItem>
                                <Divider />
                            </>
                        )}
                        {(cliente || idPedido) && (
                            <div>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar>
                                            {isDelivery ? (
                                                <Motorcycle />
                                            ) : isRetiradaNoLocal ? (
                                                <TransferWithinAStation />
                                            ) : (
                                                <AirlineSeatReclineNormal />
                                            )}
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            isDelivery
                                                ? "Pedido Para Delivery"
                                                : isRetiradaNoLocal
                                                ? "Pedido Para Retirada"
                                                : "Pedido Para Mesa"
                                        }
                                    />
                                    {isDelivery && (
                                        <ListItemText
                                            style={{ textAlign: "right" }}
                                            primary={Intl.NumberFormat("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                            }).format(
                                                isFreteGratisDesconto ||
                                                    isFreteGratisMinimoEntrega ||
                                                    !isDelivery
                                                    ? 0.0
                                                    : carrinho?.end?.taxaEntrega
                                            )}
                                        />
                                    )}
                                </ListItem>
                                {isDelivery ? (
                                    <List component="div" disablePadding>
                                        <ListItem
                                            className={classes.nested}
                                            style={{ paddingTop: "0" }}
                                        >
                                            {carrinho.end.logradouro +
                                                " - n°: " +
                                                carrinho.end.numero}
                                        </ListItem>
                                        <ListItem
                                            className={classes.nested}
                                            style={{ paddingTop: "0" }}
                                        >
                                            {carrinho.end.cidade + " - " + carrinho.end.uf}
                                        </ListItem>
                                        {carrinho.end.complemento && (
                                            <ListItem
                                                className={classes.nested}
                                                style={{ paddingTop: "0" }}
                                            >
                                                {carrinho.end.complemento}
                                            </ListItem>
                                        )}
                                        {carrinho.end.referencia && (
                                            <ListItem
                                                className={classes.nested}
                                                style={{ paddingTop: "0" }}
                                            >
                                                {carrinho.end.referencia}
                                            </ListItem>
                                        )}
                                    </List>
                                ) : null}
                                <Divider />
                                {descontoCliente?.valor || carrinho?.backUpValorDesconto ? (
                                    <>
                                        <ListItem button>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <ConfirmationNumber />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={"Desconto"} />
                                            <ListItemText
                                                style={{ textAlign: "right" }}
                                                primary={
                                                    !descontoCliente?.percentual
                                                        ? Intl.NumberFormat("pt-BR", {
                                                              style: "currency",
                                                              currency: "BRL",
                                                          }).format(
                                                              carrinho?.valorDesconto
                                                                  ? carrinho?.valorDesconto
                                                                  : carrinho?.backUpValorDesconto
                                                                  ? carrinho?.backUpValorDesconto
                                                                  : descontoCliente?.valor
                                                                  ? descontoCliente?.valor
                                                                  : 0
                                                          )
                                                        : descontoCliente?.valor + "%"
                                                }
                                                secondary={
                                                    <Button
                                                        onClick={ativarDesativarDesconto}
                                                        style={{
                                                            padding: "0px",
                                                            float: "right",
                                                            fontSize: "80%",
                                                        }}
                                                        className={
                                                            descontoAtivo
                                                                ? "desconto-ativado"
                                                                : "desconto-desativado"
                                                        }
                                                    >
                                                        {descontoAtivo ? "Ativado" : "Desativado"}
                                                    </Button>
                                                }
                                                className={
                                                    descontoAtivo
                                                        ? "desconto-ativado"
                                                        : "desconto-desativado"
                                                }
                                            />
                                        </ListItem>
                                        <List component="div" disablePadding>
                                            <ListItem
                                                className={classes.nested}
                                                style={{ paddingTop: "0" }}
                                            >
                                                {cardapio?.cupomDesconto?.codigoCupom ? (
                                                    <ListItemText
                                                        secondary={
                                                            cardapio.cupomDesconto.mensagem
                                                                ? cardapio.cupomDesconto.mensagem
                                                                : `Cupom de desconto ${
                                                                      cardapio.cupomDesconto
                                                                          .codigoCupom
                                                                  } ${
                                                                      cardapio.cupomDesconto
                                                                          .freteGratis
                                                                          ? "com frete grátis"
                                                                          : ""
                                                                  }`
                                                        }
                                                    />
                                                ) : null}
                                                {cardapio?.informacao ? (
                                                    <ListItemText
                                                        secondary={
                                                            cardapio?.informacao
                                                                ? cardapio?.informacao
                                                                : `Desconto`
                                                        }
                                                    />
                                                ) : null}
                                            </ListItem>
                                        </List>
                                        <Divider />
                                    </>
                                ) : null}
                                <TaxaAdicional />
                            </div>
                        )}

                        {carrinho?.itens?.map((item, index) => (
                            <div key={index} style={{ position: "relative" }}>
                                <ListItem button onClick={abrirEdicaoItem(item, index)}>
                                    <ListItemText
                                        primary={item.quantidade + "x " + item.produto.nome}
                                    />
                                    <ListItemText
                                        style={{
                                            textAlign: "right",
                                            flex: "0 0 auto",
                                            marginLeft: 8,
                                        }}
                                        primaryTypographyProps={{
                                            style: { whiteSpace: "nowrap" },
                                        }}
                                        primary={Intl.NumberFormat("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                        }).format(item.valorProdutoHistorico)}
                                        className="carrinho-produto-valor"
                                    />
                                </ListItem>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        padding: "0 16px 6px",
                                    }}
                                >
                                    <ButtonGroup size="small">
                                        <Button
                                            aria-label="diminuir"
                                            onClick={e => {
                                                e.stopPropagation()
                                                alterarQuantidadeItem(index, -1)
                                            }}
                                            style={{
                                                background: "var(--cor-erro)",
                                                color: "white",
                                                minWidth: 34,
                                            }}
                                        >
                                            <RemoveIcon fontSize="small" />
                                        </Button>
                                        <Button
                                            disabled
                                            style={{ color: "#000000de", minWidth: 40 }}
                                        >
                                            {item.quantidade}
                                        </Button>
                                        <Button
                                            aria-label="aumentar"
                                            onClick={e => {
                                                e.stopPropagation()
                                                alterarQuantidadeItem(index, 1)
                                            }}
                                            style={{
                                                background: "#28a745",
                                                color: "white",
                                                minWidth: 34,
                                            }}
                                        >
                                            <AddIcon fontSize="small" />
                                        </Button>
                                    </ButtonGroup>
                                </div>

                                {item.produto.promocional &&
                                (cardapio?.valorDesconto || cardapio?.percentualDesconto) ? (
                                    <List key={index} component="div" disablePadding>
                                        <ListItem
                                            className={classes.nested}
                                            style={{ paddingTop: "0" }}
                                        >
                                            <ListItemText
                                                secondary={
                                                    "É promocional, então não recebe desconto."
                                                }
                                            />
                                        </ListItem>
                                    </List>
                                ) : null}
                                {!!item.itensOpcaoProduto.length &&
                                    item?.itensOpcaoProduto?.map((adicional, index) => (
                                        <List key={index} component="div" disablePadding>
                                            <ListItem
                                                className={classes.nested}
                                                style={{ paddingTop: "0" }}
                                            >
                                                <ListItemText
                                                    secondary={
                                                        adicional.quantidade +
                                                        "x " +
                                                        adicional.opcaoProduto.nome
                                                    }
                                                />
                                            </ListItem>
                                        </List>
                                    ))}

                                <Divider />
                            </div>
                        ))}

                        {!carrinho?.itens?.length && (
                            <div
                                style={{
                                    textAlign: "center",
                                    color: "#9e9e9e",
                                    padding: "4em 1.5em",
                                }}
                            >
                                <AddShoppingCart style={{ fontSize: 56, opacity: 0.5 }} />
                                <Typography style={{ marginTop: "0.5em", fontWeight: 600 }}>
                                    Carrinho vazio
                                </Typography>
                                <Typography variant="body2">
                                    Escolha os itens no cardápio para adicionar ao pedido.
                                </Typography>
                            </div>
                        )}
                    </div>
                    <ListSubheader
                        component="div"
                        id="nested-list-subheader"
                        className="mt-2"
                        style={{ backgroundColor: "#fff", marginTop: "auto" }}
                    >
                        <Row
                            style={{
                                width: "100%",
                                top: "auto",
                                padding: "0",
                                margin: "0",
                            }}
                        >
                            {(isDelivery ||
                                isRetiradaNoLocal ||
                                carrinho?.tipoPedido === 2) && (
                                <Col
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 6,
                                        padding: "0 0 6px",
                                        color: "#6c757d",
                                    }}
                                >
                                    {isDelivery ? (
                                        <Motorcycle fontSize="small" />
                                    ) : isRetiradaNoLocal ? (
                                        <TransferWithinAStation fontSize="small" />
                                    ) : (
                                        <AirlineSeatReclineNormal fontSize="small" />
                                    )}
                                    <Typography variant="body2" style={{ fontWeight: 600 }}>
                                        {isDelivery
                                            ? "Delivery"
                                            : isRetiradaNoLocal
                                            ? "Retirada"
                                            : "Mesa"}
                                    </Typography>
                                </Col>
                            )}
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    variant="contained"
                                    onClick={e => {
                                        toggleDrawer("right", false)(e)

                                        if (carrinho.tipoPedido === 2) {
                                            const formaPagamento = cardapio.formaPagamento.filter(
                                                pg => pg.id === 41
                                            ) // forma pagamento pedido mesa
                                            if (formaPagamento.length) {
                                                carrinho.formaPagamento = formaPagamento[0]
                                            }
                                        }

                                        if (cliente || carrinho.tipoPedido === 2 || idPedido) {
                                            setOpenFinalizacaoPedido(true)
                                        } else {
                                            handleToggleParteInicial()
                                        }
                                    }}
                                    fullWidth
                                    style={{ background: "#28a745", color: "white" }}
                                >
                                    {`Finalizar ${Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(valorTotalExibicao)}`}
                                </Button>
                            </Col>
                            {!!carrinho?.itens?.length && (
                                <Col
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    style={{ textAlign: "center", marginTop: 4 }}
                                >
                                    <Button
                                        variant="text"
                                        size="small"
                                        disableRipple
                                        onClick={pedirConfirmacaoLimparPedido}
                                        style={{
                                            color: "var(--cor-erro)",
                                            textDecoration: "underline",
                                            textTransform: "none",
                                        }}
                                    >
                                        Limpar pedido
                                    </Button>
                                </Col>
                            )}
                        </Row>
                    </ListSubheader>
                </List>
            }
        </div>
    )

    const adicionarProduto = (anchor, open, produto) => event => {
        setOpenFinalizacaoPedido(false)
        try {

            if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return
            }
            // No mobile, mantém o cardápio ativo ao adicionar — o carrinho (Drawer) só
            // abre ao tocar no botão "Carrinho". No desktop o carrinho fica sempre
            // visível no painel lateral, então `right` é inofensivo.
            setState({ ...state, [anchor]: open, right: !mobile })

            const grupoExtraIndexes = produto.opcoes.reduce((acc, op, index) => {
                if (op.grupoExtra) acc.push(index)
                return acc
            }, [])

            const produtoSuccess = produtoProntoParaCarrinho(produto)

            for (let i = grupoExtraIndexes.length - 1; i >= 0; i--) {
                produto.opcoes.splice(grupoExtraIndexes[i], 1)
            }

            let cart = Object.assign({}, carrinho)
            cart.itens.push(produtoSuccess)
            cart = calcularValorTotal({
                descontoAtivoPagamento,
                carrinho: cart,
                cardapio,
                descontoAtivo,
                isDelivery,
                ativoMinimoEntregaGratis,
                valorDescontoManual,
                taxaServico: carrinho.taxaServico,
                descontoCliente,
            })
            setCarrinho(cart)
            setActiveStep(0)
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "adicionarProduto", { anchor, open, produto, event })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    // Adiciona o produto direto no carrinho (sem popup). A observação vai vazia (o
    // campo do popup nem existe aqui; produtoProntoParaCarrinho já trata isso).
    // `preSelecao` (opcional, { indiceGrupo, idOpcao }) marca uma opção já selecionada —
    // usado ao bipar o código PDV de um item de opção/adicional específico.
    // `quantidade` (padrão 1) permite bipar "N*codigo" para já entrar com N unidades.
    const adicionarProdutoDireto = (produtoOriginal, preSelecao = null, quantidade = 1) => {
        try {
            const produto = deepClone(produtoOriginal)
            produto.quantidade = quantidade > 0 ? quantidade : 1
            ;(produto.opcoes || []).forEach(grupo => {
                grupo.quantidade = 0
                ;(grupo.opcoes || []).forEach(op => (op.quantidade = 0))
            })

            if (preSelecao && produto.opcoes?.[preSelecao.indiceGrupo]) {
                const grupo = produto.opcoes[preSelecao.indiceGrupo]
                const item = (grupo.opcoes || []).find(op => op.id === preSelecao.idOpcao)
                if (item) {
                    item.quantidade = 1
                    grupo.quantidade = 1
                }
            }

            const grupoExtraIndexes = (produto.opcoes || []).reduce((acc, op, index) => {
                if (op.grupoExtra) acc.push(index)
                return acc
            }, [])

            const produtoSuccess = produtoProntoParaCarrinho(produto)

            for (let i = grupoExtraIndexes.length - 1; i >= 0; i--) {
                produto.opcoes.splice(grupoExtraIndexes[i], 1)
            }

            let cart = Object.assign({}, carrinho)
            cart.itens.push(produtoSuccess)
            cart = calcularValorTotal({
                descontoAtivoPagamento,
                carrinho: cart,
                cardapio,
                descontoAtivo,
                isDelivery,
                ativoMinimoEntregaGratis,
                valorDescontoManual,
                taxaServico: carrinho.taxaServico,
                descontoCliente,
            })
            setCarrinho(cart)
            setActiveStep(0)
            return true
        } catch (error) {
            RegistrarLogErro(error, "adicionarProdutoDireto", { produtoOriginal })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            return false
        }
    }

    // Abre o popup de opções de um produto (quando ele tem opções para escolher).
    // `quantidade` (padrão 1) preenche a quantidade inicial — usado no bipar "N*codigo".
    const abrirOpcoesProduto = (produtoOriginal, idCategoria, quantidade = 1) => {
        const produto = deepClone(produtoOriginal)
        produto.quantidade = quantidade > 0 ? quantidade : 1
        ;(produto.opcoes || []).forEach(grupo => {
            grupo.quantidade = 0
            ;(grupo.opcoes || []).forEach(op => (op.quantidade = 0))
        })

        setModoEdicao(false)
        setIndiceItemEmEdicao(null)
        setProdutoSelecionado(produto)
        setIdCategoriaSelecionada(idCategoria)
        setActiveStep(0)
        setState(prev => ({ ...prev, bottom: true }))
    }

    // Clique no card do produto: com opções → abre o popup; sem opções → adiciona
    // direto (não faz sentido perguntar quantidade/observação num popup só pra isso —
    // a quantidade é ajustável no próprio carrinho).
    const handleClickProduto = (produto, idCategoria) => event => {
        try {
            if (event?.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return
            }
            const perguntarQtdObs = lerConfigTela().perguntarQuantidadeObservacao

            if ((produto.opcoes || []).length > 0 || perguntarQtdObs) {
                // Com opções → popup normal. Sem opções, mas com a config ligada →
                // abre o popup mesmo assim: como não há grupos, ele já cai direto na
                // tela final de quantidade/observação (activeStep 0 === opcoes.length 0).
                abrirOpcoesProduto(produto, idCategoria)
            } else {
                adicionarProdutoDireto(produto)
            }
        } catch (error) {
            RegistrarLogErro(error, "handleClickProduto", { produto, idCategoria })
        }
    }

    // Executa um match de código PDV (produto ou item de opção).
    // - Produto com opções → abre o popup (o operador escolhe as opções);
    //   sem opções → adiciona direto.
    // - Item de opção → o código já define exatamente a variante, então adiciona
    //   direto ao carrinho (quantidade 1) com aquela opção marcada, sem popup.
    const executarMatchCodigo = (match, quantidade = 1) => {
        if (!match) return false
        if (match.tipo === "produto") {
            if ((match.produto.opcoes || []).length > 0) {
                abrirOpcoesProduto(match.produto, match.idCategoria, quantidade)
                return true
            }
            return adicionarProdutoDireto(match.produto, null, quantidade)
        }
        return adicionarProdutoDireto(
            match.produto,
            { indiceGrupo: match.indiceGrupo, idOpcao: match.idOpcao },
            quantidade
        )
    }

    // Busca por código PDV (fluxo "bipar" um código e dar Enter). O código pode casar
    // com um produto (campo `codigo`) e/ou com um item de opção/adicional
    // (`produto.opcoes[].opcoes[].codigo`). Coleta TODOS os matches:
    // - 0 → aviso;
    // - 1 → executa direto;
    // - >1 → abre um seletor para o operador escolher o item.
    // Aceita o prefixo de quantidade "N*codigo" (ex.: "2*9768000151" → 2 unidades).
    const adicionarPorCodigoPdv = codigo => {
        let entrada = String(codigo ?? "").trim()
        if (!entrada) return false

        // Prefixo de quantidade: "N*codigo" (espaços ao redor do * são tolerados).
        let quantidade = 1
        const comQuantidade = entrada.match(/^(\d+)\s*\*\s*(.+)$/)
        if (comQuantidade) {
            quantidade = parseInt(comQuantidade[1], 10) || 1
            entrada = comQuantidade[2].trim()
        }

        const alvo = entrada
        if (!alvo) return false

        const matches = []
        for (const categoria of cardapio?.categorias || []) {
            for (const prod of categoria.produtos || []) {
                if (prod.codigo != null && String(prod.codigo).trim() === alvo) {
                    matches.push({
                        tipo: "produto",
                        produto: prod,
                        idCategoria: categoria.id,
                        rotulo: prod.nome,
                        rotuloSecundario: categoria.nome,
                    })
                }
                for (let g = 0; g < (prod.opcoes || []).length; g++) {
                    const grupo = prod.opcoes[g]
                    ;(grupo.opcoes || []).forEach(item => {
                        if (item.codigo != null && String(item.codigo).trim() === alvo) {
                            matches.push({
                                tipo: "opcao",
                                produto: prod,
                                idCategoria: categoria.id,
                                indiceGrupo: g,
                                idOpcao: item.id,
                                rotulo: item.nome,
                                rotuloSecundario: `${prod.nome} • ${grupo.nome}`,
                            })
                        }
                    })
                }
            }
        }

        if (matches.length === 0) {
            alertStart(`Nenhum produto ou opção com código PDV "${alvo}".`, "warning")
            return false
        }

        if (matches.length === 1) {
            return executarMatchCodigo(matches[0], quantidade)
        }

        // Mais de um item com o mesmo código: deixa o operador escolher (mantendo a
        // quantidade informada no prefixo "N*codigo").
        setMatchesCodigo({ codigo: alvo, itens: matches, quantidade })
        return true
    }

    const [valorPesquisa, setValorPesquisa] = useState()
    const [categoriaAtiva, setCategoriaAtiva] = useState(-1)
    // Seletor exibido quando um mesmo código PDV casa com mais de um item.
    // { codigo, itens: [...] } enquanto aberto; null quando fechado.
    const [matchesCodigo, setMatchesCodigo] = useState(null)

    const [categoriasFiltradas, setCategoriasFiltradas] = useState(null)
    const tiposPedido = {
        0: "DELIVERY",
        1: "REGISTRADOR",
        2: "PEDIDO_MESA",
    }

    // Configurações da tela (por estação), persistidas em localStorage. A chave e os
    // padrões vivem em functions.js (CONFIG_TELA_PADRAO), lidos também pelo index.js.
    const [configTela, setConfigTela] = useState(lerConfigTela)
    const [anchorConfig, setAnchorConfig] = useState(null)

    const atualizarConfig = chave => e => {
        const novo = { ...configTela, [chave]: e.target.checked }
        setConfigTela(novo)
        localStorage.setItem(CONFIG_TELA_KEY, JSON.stringify(novo))
    }

    // Variante para configs de VALOR (não booleanas), ex.: tamanho do card.
    const atualizarConfigValor = chave => e => {
        const novo = { ...configTela, [chave]: e.target.value }
        setConfigTela(novo)
        localStorage.setItem(CONFIG_TELA_KEY, JSON.stringify(novo))
    }

    // Colunas do grid por tamanho de card (menos colunas por linha = card maior). Casa
    // com as regras .tamanho-* do styles.css (altura da imagem e fontes).
    const COLUNAS_POR_TAMANHO = {
        pequeno: { xs: 4, sm: 4, md: 3, lg: 2, xl: 2 },
        normal: { xs: 6, sm: 6, md: 4, lg: 3, xl: 2 },
        grande: { xs: 6, sm: 6, md: 6, lg: 4, xl: 3 },
    }
    const colunasCard = COLUNAS_POR_TAMANHO[configTela.tamanhoCard] || COLUNAS_POR_TAMANHO.normal

    // Tabs de categoria no topo (no lugar do <Select>). Conforme a configuração:
    // - categoriaFiltrar: mostra só a categoria clicada (esconde as demais);
    // - senão: mantém todas visíveis e apenas ROLA até a categoria clicada.
    // O id "primerioC{index}" casa com o index do map de categoriasFiltradas.
    const selecionarCategoriaTab = indexCategoria => {
        const permitirBuscaPorAdicionais =
            configuracoes.user?.parametros?.permitirBuscaPorAdicionais
        setValorPesquisa("")
        setCategoriaAtiva(indexCategoria)

        if (configTela.categoriaFiltrar) {
            procurarProduto("", cardapio, permitirBuscaPorAdicionais)
            procurarCategoria({ target: { value: indexCategoria } })
            return
        }

        // Rolar: garante todas visíveis e aguarda o DOM antes de rolar.
        procurarProduto("", cardapio, permitirBuscaPorAdicionais)
        requestAnimationFrame(() => {
            const alvo =
                indexCategoria === -1
                    ? document.getElementById("produtosDasCategorias")
                    : document.getElementById("primerioC" + indexCategoria)
            alvo?.scrollIntoView({ behavior: "smooth", block: "start" })
        })
    }

    useEffect(() => {
        if (!cardapio?.categorias) return
        if (carrinho?.tipoPedido == null) {
            setCategoriasFiltradas(cardapio.categorias)
            return
        }
        const tipoPedido = tiposPedido[carrinho.tipoPedido]
        const filtradas = cardapio.categorias.filter(c => {
            if (c.exibicaoCategoriaEnum == null) return true
            return (
                c.exibicaoCategoriaEnum === tipoPedido || c.exibicaoCategoriaEnum === "REGISTRADOR"
            )
        })
        setCategoriasFiltradas(filtradas)
    }, [cardapio, carrinho?.tipoPedido])

    return openCardapio && carrinho.estabelecimento ? (
        <Dialog
            fullScreen
            open={openCardapio}
            onClose={handleCloseCardapio}
            TransitionComponent={Transition}
            style={{
                zIndex: 1,
                // Abre espaço para o rail lateral do menu do Cabeçalho (desktop, fora de iframe).
                paddingLeft: !iframe && !mobile ? "var(--drawer-width, 80px)" : "",
                transition: "padding-left 0.2s ease",
            }}
            disableEnforceFocus={openParteInicial}
            disableAutoFocus={openParteInicial}
            disableRestoreFocus={openParteInicial}
        >
            {/* Topo padronizado: fora de iframe o Cabeçalho padrão (montado no index.js)
                já aparece POR CIMA deste Dialog — o Dialog tem z-index 1 de propósito (para
                o overlay de busca de cliente abrir sobre ele) e o AppBar do Cabeçalho é
                position:fixed (z-index ~1100). Por isso NÃO montamos outro Cabeçalho aqui:
                seria redundante e ainda ficaria escondido atrás do raiz. No iframe (sem
                Cabeçalho) mostramos uma barra enxuta com o nome do estabelecimento. */}
            {iframe && (
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            {carrinho.estabelecimento.nome}
                        </Typography>
                    </Toolbar>
                </AppBar>
            )}

            {/* Carrinho: no desktop fica SEMPRE visível num painel fixo à direita; no
                mobile continua como Drawer aberto pelo FAB (não há espaço para o painel). */}
            {mobile ? (
                <>
                    <Drawer
                        anchor={"right"}
                        open={state["right"]}
                        onClose={toggleDrawer("right", false)}
                    >
                        {list("right")}
                    </Drawer>

                    <Fab
                        variant="extended"
                        aria-label="carrinho"
                        className={classes.fixedCarrinho}
                        onClick={toggleDrawer("right", true)}
                        style={{ backgroundColor: "#28a745", color: "white" }}
                    >
                        <AddShoppingCart style={{ marginRight: "6px" }} /> Finalizar{" "}
                        ({quantidadeItensCarrinho}{" "}
                        {quantidadeItensCarrinho === 1 ? "item" : "itens"})
                    </Fab>
                </>
            ) : (
                <aside className={classes.cartPanel} style={{ width: larguraCarrinho }}>
                    <div
                        className={classes.cartResizeHandle}
                        onPointerDown={iniciarRedimensionarCarrinho}
                        title="Arraste para ajustar a largura do carrinho"
                    />
                    {list("right")}
                </aside>
            )}

            {/* Confirmação de "Limpar pedido" — Dialog em vez de window.confirm para ficar
                mais visível/legível do que o popup nativo do navegador. */}
            <Dialog
                open={openConfirmarLimparPedido}
                onClose={() => setOpenConfirmarLimparPedido(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Limpar pedido?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Todos os {quantidadeItensCarrinho}{" "}
                        {quantidadeItensCarrinho === 1 ? "item" : "itens"} adicionados ao
                        pedido serão removidos. O cliente, endereço e mesa selecionados são
                        mantidos. Essa ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: "8px 24px 16px" }}>
                    <Button onClick={() => setOpenConfirmarLimparPedido(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={confirmarLimparPedido}
                        style={{ background: "var(--cor-erro)", color: "white" }}
                    >
                        Limpar pedido
                    </Button>
                </DialogActions>
            </Dialog>

            <Row
                style={{
                    margin: 0,
                    paddingRight: !mobile ? larguraCarrinho : 0,
                    // No desktop, a área central vira um container de altura fixa: só a
                    // lista de produtos rola (com barra sempre visível), em vez de rolar
                    // a janela inteira — assim a barra fica na PARTE CENTRAL, e não lá na
                    // extrema direita atrás do carrinho fixo. No mobile mantém o scroll da
                    // página (o carrinho é um Drawer).
                    ...(!mobile && {
                        height: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }),
                }}
                className={classes.appContainer}
            >
                {loadingCardapio ? (
                    <Col xs={12} md={12} lg={12}>
                        <Row>
                            <Col xs={12} md={6} lg={6}>
                                <Skeleton variant="rect" width={"100%"} height={65} />
                            </Col>
                            <Col
                                xs={12}
                                md={3}
                                lg={3}
                                style={{ textAlign: "center", alignSelf: "center" }}
                            >
                                <Skeleton variant="rect" width={"100%"} height={35} />
                            </Col>
                            <Col
                                xs={12}
                                md={3}
                                lg={3}
                                style={{ textAlign: "center", alignSelf: "center" }}
                            >
                                <Skeleton variant="rect" width={"100%"} height={35} />
                            </Col>
                        </Row>

                        {listaRepeticao?.map((chave, index) => (
                            <React.Fragment key={index}>
                                <Row style={{ padding: "2em 0" }}>
                                    <Col xs={12} md={5} lg={4}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={35}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={4} lg={3}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={258}
                                        />
                                    </Col>
                                    <Col xs={6} md={4} lg={3}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={258}
                                        />
                                    </Col>
                                    <Col xs={6} md={4} lg={3}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={258}
                                        />
                                    </Col>
                                    <Col xs={6} md={4} lg={3}>
                                        <Skeleton
                                            key={chave}
                                            variant="rect"
                                            width={"100%"}
                                            height={258}
                                        />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        ))}
                    </Col>
                ) : (
                    <>
                        <div
                            className="registrador-topbar"
                            style={{
                                width: "100%",
                                // No desktop a barra de topo é filha do container de altura
                                // fixa (não rola com a página), então o sticky com offset de
                                // 64px só criaria um vão. Fixa no topo do container.
                                ...(!mobile && { position: "static" }),
                            }}
                        >
                            <Grid
                                container
                                spacing={1}
                                xs={12}
                                md={10}
                                lg={10}
                                justifyContent="center"
                                style={{ marginInline: "auto" }}
                            >
                                <Grid item xs={12}>
                                    {/* Busca, "Tipo pedido" e "Categoria" (quando em caixa de seleção)
                                    ficam na mesma linha flexível — quebram individualmente só quando
                                    faltar espaço. A engrenagem de configurações sempre fica por último. */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 8,
                                            alignItems: "center",
                                        }}
                                    >
                                        <TextField
                                            value={valorPesquisa}
                                            id="procurar-produto"
                                            // Só foca a busca de produto quando a seleção de
                                            // cliente (ParteInicial) NÃO está aberta — nesse
                                            // caso o foco deve ir para a busca de cliente.
                                            autoFocus={!openParteInicial}
                                            onChange={e => {
                                                const valorDigitado = e.target.value
                                                procurarProduto(
                                                    valorDigitado,
                                                    cardapio,
                                                    configuracoes.user?.parametros
                                                        ?.permitirBuscaPorAdicionais
                                                )
                                                setValorPesquisa(valorDigitado)
                                                setCategoriaAtiva(-1)
                                            }}
                                            onKeyDown={e => {
                                                if (e.key !== "Enter") return
                                                e.preventDefault()
                                                // Enter: tenta adicionar pelo código PDV.
                                                // Só limpa/reseta se realmente adicionou.
                                                const adicionou = adicionarPorCodigoPdv(
                                                    e.target.value
                                                )
                                                if (adicionou) {
                                                    setValorPesquisa("")
                                                    setCategoriaAtiva(-1)
                                                    procurarProduto(
                                                        "",
                                                        cardapio,
                                                        configuracoes.user?.parametros
                                                            ?.permitirBuscaPorAdicionais
                                                    )
                                                }
                                            }}
                                            size="small"
                                            label="Procurar ou bipar código"
                                            variant="outlined"
                                            style={{
                                                background: "#fff",
                                                flex: "1 1 180px",
                                                minWidth: 160,
                                            }}
                                        />
                                        {estabelecimentosDisponiveis?.length === 1 && (
                                            <FormControl
                                                variant="outlined"
                                                size="small"
                                                style={{
                                                    background: "#fff",
                                                    flex: "1 1 160px",
                                                    minWidth: 150,
                                                }}
                                            >
                                                <InputLabel id="select-tipo-pedido-label">
                                                    Tipo pedido
                                                </InputLabel>
                                                <Select
                                                    defaultValue={-1}
                                                    labelId="select-tipo-pedido-label"
                                                    id="select-tipo-pedido"
                                                    label="Tipo pedido"
                                                    onChange={e => {
                                                        localStorage.setItem(
                                                            "tipoPedido",
                                                            e.target.value
                                                        )
                                                        setTipo(e.target.value)
                                                    }}
                                                    value={tipo}
                                                >
                                                    <MenuItem key={-1} value={""}>
                                                        Todos
                                                    </MenuItem>
                                                    {tipoEntregas?.map(t => {
                                                        return (
                                                            <MenuItem key={t} value={t}>
                                                                {textoTipoEntregas[t]}
                                                            </MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* Filtro de categoria: chips clicáveis (padrão) ou caixa de seleção,
                                        conforme configTela.filtroCategoriaEstilo — ver "Configurações da tela". */}
                                        {configTela.filtroCategoriaEstilo === "select" && (
                                            <FormControl
                                                variant="outlined"
                                                size="small"
                                                style={{
                                                    background: "#fff",
                                                    flex: "1 1 180px",
                                                    minWidth: 170,
                                                }}
                                            >
                                                <InputLabel id="select-categoria-label">
                                                    Categoria
                                                </InputLabel>
                                                <Select
                                                    labelId="select-categoria-label"
                                                    label="Categoria"
                                                    value={categoriaAtiva}
                                                    onChange={e =>
                                                        selecionarCategoriaTab(e.target.value)
                                                    }
                                                >
                                                    <MenuItem value={-1}>Todas</MenuItem>
                                                    {categoriasFiltradas?.map((categoria, index) =>
                                                        categoria.produtos.length ? (
                                                            <MenuItem key={index} value={index}>
                                                                {categoria.nome}
                                                            </MenuItem>
                                                        ) : null
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        <IconButton
                                            aria-label="configurações da tela"
                                            onClick={e => setAnchorConfig(e.currentTarget)}
                                            style={{ background: "#fff", flexShrink: 0 }}
                                        >
                                            <Settings />
                                        </IconButton>
                                    </div>
                                </Grid>
                                {configTela.filtroCategoriaEstilo !== "select" && (
                                    <Grid item xs={12}>
                                        <div className="registrador-categorias-tabs">
                                            <Chip
                                                label="Todas"
                                                clickable
                                                color={
                                                    categoriaAtiva === -1 ? "primary" : "default"
                                                }
                                                onClick={() => selecionarCategoriaTab(-1)}
                                            />
                                            {categoriasFiltradas?.map((categoria, index) =>
                                                categoria.produtos.length ? (
                                                    <Chip
                                                        key={index}
                                                        label={categoria.nome}
                                                        clickable
                                                        color={
                                                            categoriaAtiva === index
                                                                ? "primary"
                                                                : "default"
                                                        }
                                                        onClick={() =>
                                                            selecionarCategoriaTab(index)
                                                        }
                                                    />
                                                ) : null
                                            )}
                                        </div>
                                    </Grid>
                                )}
                            </Grid>
                        </div>

                        <Popover
                            open={Boolean(anchorConfig)}
                            anchorEl={anchorConfig}
                            onClose={() => setAnchorConfig(null)}
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                            <div style={{ padding: "1em 1.5em", maxWidth: 320 }}>
                                <Typography style={{ fontWeight: "bold", marginBottom: 8 }}>
                                    Configurações da tela
                                </Typography>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={configTela.selecionarClienteInicio}
                                                onChange={atualizarConfig(
                                                    "selecionarClienteInicio"
                                                )}
                                            />
                                        }
                                        label="Selecionar cliente no início (senão abre direto no cardápio)"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={configTela.categoriaFiltrar}
                                                onChange={atualizarConfig("categoriaFiltrar")}
                                            />
                                        }
                                        label="Ao clicar na categoria, filtrar (ocultar as demais)"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={configTela.mostrarDescricao}
                                                onChange={atualizarConfig("mostrarDescricao")}
                                            />
                                        }
                                        label="Exibir descrição do produto no card"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={configTela.mostrarCodigoPdv}
                                                onChange={atualizarConfig("mostrarCodigoPdv")}
                                            />
                                        }
                                        label="Exibir código PDV no card"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={configTela.fotoDestaque}
                                                onChange={atualizarConfig("fotoDestaque")}
                                            />
                                        }
                                        label="Foto com destaque (ocupa toda a largura do card)"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={configTela.perguntarQuantidadeObservacao}
                                                onChange={atualizarConfig(
                                                    "perguntarQuantidadeObservacao"
                                                )}
                                            />
                                        }
                                        label="Perguntar quantidade e observação ao adicionar item"
                                    />
                                </FormGroup>
                                <div style={{ marginTop: 12 }}>
                                    <Typography
                                        variant="body2"
                                        style={{ marginBottom: 4, color: "#2c3e50" }}
                                    >
                                        Tamanho do card
                                    </Typography>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            value={configTela.tamanhoCard}
                                            onChange={atualizarConfigValor("tamanhoCard")}
                                        >
                                            <MenuItem value="pequeno">Pequeno</MenuItem>
                                            <MenuItem value="normal">Normal</MenuItem>
                                            <MenuItem value="grande">Grande</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div style={{ marginTop: 12 }}>
                                    <Typography
                                        variant="body2"
                                        style={{ marginBottom: 4, color: "#2c3e50" }}
                                    >
                                        Filtro de categorias
                                    </Typography>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            value={configTela.filtroCategoriaEstilo}
                                            onChange={atualizarConfigValor(
                                                "filtroCategoriaEstilo"
                                            )}
                                        >
                                            <MenuItem value="botao">Botões</MenuItem>
                                            <MenuItem value="select">Caixa de seleção</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </Popover>

                        <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className={!mobile ? "cardapio-central-scroll" : undefined}
                            style={
                                !mobile
                                    ? { flex: 1, minHeight: 0, overflowY: "scroll" }
                                    : { height: "100%" }
                            }
                        >
                            <TabPanel id="produtosDasCategorias">
                                {cardapio?.id &&
                                    categoriasFiltradas?.map((categoria, indexC) =>
                                        categoria.produtos.length ? (
                                            <Row
                                                key={indexC}
                                                id={"primerioC" + indexC}
                                                className={"CardCategoriaCol"}
                                                data-id-categoria={categoria.id}
                                            >
                                                <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginTop: "1em" }}
                                                >
                                                    <Typography style={{ fontSize: "1.2rem" }}>
                                                        <span style={{ fontWeight: "bold" }}>
                                                            {categoria.exibicaoCategoriaEnum &&
                                                            categoria.exibicaoCategoriaEnum ===
                                                                "PEDIDO_MESA"
                                                                ? "Mesa "
                                                                : categoria.exibicaoCategoriaEnum ===
                                                                  "DELIVERY"
                                                                ? "Delivery "
                                                                : categoria.exibicaoCategoriaEnum ===
                                                                  "REGISTRADOR"
                                                                ? "Registrador "
                                                                : null}
                                                        </span>
                                                        -{" "}
                                                        {categoria.nome[0].toLocaleUpperCase() +
                                                            categoria.nome
                                                                .substring(1)
                                                                .toLocaleLowerCase()}{" "}
                                                    </Typography>
                                                </Col>
                                                {categoria.produtos.map((produto, indexP) =>
                                                    produto?.nome ===
                                                    "Adicionais Associados" ? null : (
                                                        <Col
                                                            xs={colunasCard.xs}
                                                            sm={colunasCard.sm}
                                                            md={colunasCard.md}
                                                            lg={colunasCard.lg}
                                                            xl={colunasCard.xl}
                                                            key={produto.id}
                                                            data-id-produto={produto.id}
                                                            className={`CardProdutoCol tamanho-${configTela.tamanhoCard}`}
                                                        >
                                                            <Card
                                                                className={`${
                                                                    classes.rootProduto
                                                                } ${
                                                                    produto.promocional
                                                                        ? "CardProdutoColPromocional"
                                                                        : null
                                                                }`}
                                                                style={{ height: "100%" }}
                                                                onClick={handleClickProduto(
                                                                    produto,
                                                                    categoria.id
                                                                )}
                                                            >
                                                                <CardActionArea
                                                                    style={
                                                                        {
                                                                            /*"height": "100%"*/
                                                                        }
                                                                    }
                                                                >
                                                                    <CardMedia
                                                                        className={`${
                                                                            produto.urlImagem
                                                                                ? ""
                                                                                : "opacity05"
                                                                        } produtoDeGrid ${
                                                                            configTela.fotoDestaque &&
                                                                            produto.urlImagem
                                                                                ? "produtoFotoDestaque"
                                                                                : ""
                                                                        }`}
                                                                        image={
                                                                            produto.urlImagem
                                                                                ? produto.urlImagem
                                                                                : produto.produtoExibicao
                                                                                ? Megafone
                                                                                : /**Prato */ Comida
                                                                        }
                                                                        title={produto.nome}
                                                                    />
                                                                    <CardContent>
                                                                        <Typography
                                                                            gutterBottom
                                                                            style={{
                                                                                fontSize: "0.9rem",
                                                                                textAlign:
                                                                                    configTela.fotoDestaque &&
                                                                                    produto.urlImagem
                                                                                        ? "center"
                                                                                        : "left",
                                                                            }}
                                                                            className="nomeProduto"
                                                                        >
                                                                            {produto.nome}
                                                                        </Typography>
                                                                        {configTela.mostrarCodigoPdv &&
                                                                        produto.codigo ? (
                                                                            <Typography
                                                                                variant="caption"
                                                                                component="p"
                                                                                className="codigoPdvProduto"
                                                                            >
                                                                                {produto.codigo}
                                                                            </Typography>
                                                                        ) : null}
                                                                        {configTela.mostrarDescricao && (
                                                                            <Typography
                                                                                variant="subtitle2"
                                                                                color="textSecondary"
                                                                                className="descricaoProduto"
                                                                                component="p"
                                                                            >
                                                                                {produto.descricao &&
                                                                                produto.descricao
                                                                                    .length > 80
                                                                                    ? produto.descricao.substring(
                                                                                          0,
                                                                                          mobile
                                                                                              ? 40
                                                                                              : 80
                                                                                      ) + " [...]"
                                                                                    : produto.descricao}
                                                                            </Typography>
                                                                        )}

                                                                        {produto.produtoExibicao ? (
                                                                            <Typography
                                                                                variant="body2"
                                                                                className="valorProduto"
                                                                                component="p"
                                                                            >
                                                                                Aviso
                                                                            </Typography>
                                                                        ) : (
                                                                            <Typography
                                                                                variant="body2"
                                                                                className="valorProduto"
                                                                                component="p"
                                                                            >
                                                                                {produto.valorDe &&
                                                                                produto.valorDeCalculado >
                                                                                    0 ? (
                                                                                    <span
                                                                                        style={{
                                                                                            textDecorationLine:
                                                                                                "line-through",
                                                                                            fontSize:
                                                                                                "0.8rem",
                                                                                            color: "rgba(220, 53, 99, 0.54)",
                                                                                        }}
                                                                                    >
                                                                                        {Intl.NumberFormat(
                                                                                            "pt-BR",
                                                                                            {
                                                                                                style: "currency",
                                                                                                currency:
                                                                                                    "BRL",
                                                                                            }
                                                                                        ).format(
                                                                                            produto.valorDe
                                                                                        )}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span></span>
                                                                                )}

                                                                                <span className="valorProdutoPromocional">
                                                                                    {" "}
                                                                                    {produto.valorRealCalculado >
                                                                                        0 &&
                                                                                        Intl.NumberFormat(
                                                                                            "pt-BR",
                                                                                            {
                                                                                                style: "currency",
                                                                                                currency:
                                                                                                    "BRL",
                                                                                            }
                                                                                        ).format(
                                                                                            produto.valorRealCalculado
                                                                                        )}
                                                                                </span>
                                                                            </Typography>
                                                                        )}
                                                                    </CardContent>
                                                                </CardActionArea>
                                                            </Card>
                                                        </Col>
                                                    )
                                                )}
                                            </Row>
                                        ) : null
                                    )}
                            </TabPanel>
                        </Col>
                        {cardapio?.id && produtoSelecionado.id ? (
                            <Dialog
                                open={state["bottom"]}
                                onClose={toggleDrawer("bottom", false)}
                                maxWidth="sm"
                                fullWidth
                                scroll="paper"
                                PaperProps={{ className: "popup-produto-paper" }}
                            >
                                <Product
                                    anchor="bottom"
                                    useStyles={useStyles}
                                    produtoSelecionado={produtoSelecionado}
                                    setProdutoSelecionado={setProdutoSelecionado}
                                    activeStep={activeStep}
                                    setActiveStep={setActiveStep}
                                    alertStart={alertStart}
                                    adicionarProduto={adicionarProduto}
                                    skipped={skipped}
                                    setSkipped={setSkipped}
                                    idCategoriaSelecionada={idCategoriaSelecionada}
                                    clsx={clsx}
                                    state={state}
                                    setState={setState}
                                    emEdicao={modoEdicao}
                                    salvarEdicao={salvarEdicaoProduto}
                                    perguntarQuantidadeObservacao={
                                        configTela.perguntarQuantidadeObservacao
                                    }
                                />
                            </Dialog>
                        ) : null}

                        {/* Seletor exibido quando um mesmo código PDV casa com mais de
                            um item (produtos e/ou itens de opção). */}
                        <Dialog
                            open={Boolean(matchesCodigo)}
                            onClose={() => setMatchesCodigo(null)}
                            maxWidth="xs"
                            fullWidth
                        >
                            <Box
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "12px 16px",
                                }}
                            >
                                <Typography variant="h6">
                                    Código {matchesCodigo?.codigo}
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => setMatchesCodigo(null)}
                                    aria-label="Fechar"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{ padding: "0 16px 8px" }}
                            >
                                Este código está em mais de um item. Escolha qual deseja
                                adicionar:
                            </Typography>
                            <List>
                                {(matchesCodigo?.itens || []).map((match, i) => (
                                    <ListItem
                                        button
                                        divider
                                        key={`${match.tipo}-${match.idOpcao ?? match.produto.id}-${i}`}
                                        onClick={() => {
                                            executarMatchCodigo(
                                                match,
                                                matchesCodigo?.quantidade ?? 1
                                            )
                                            setMatchesCodigo(null)
                                        }}
                                    >
                                        <ListItemText
                                            primary={match.rotulo}
                                            secondary={
                                                match.tipo === "opcao"
                                                    ? `Opção • ${match.rotuloSecundario}`
                                                    : `Produto • ${match.rotuloSecundario}`
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Dialog>
                    </>
                )}
            </Row>
        </Dialog>
    ) : (
        <React.Fragment></React.Fragment>
    )
}
